import script from "./ClientLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientLayout.vue?vue&type=script&lang=ts&setup=true"

import "./ClientLayout.vue?vue&type=style&index=0&id=0f0c63b9&lang=css"

const __exports__ = script;

export default __exports__